import React, { useState } from "react";
import { axiosService } from 'shared/helpers/axios';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  Box,
  CircularProgress
} from '@mui/material';

const SendEmailsPage = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSendEmails = async () => {
    if (!subject || !message) {
      setErrorMessage("Subject and message are required.");
      return;
    }

    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      const data = { subject, message };
      
      // Debug logging
      console.log('axiosService defaults:', axiosService.defaults);
      console.log('Sending data:', data);
      
      // Choose ONE URL - pick the correct one based on your backend
      // Option 1: If backend is at /users/send-email/
      // const response = await axiosService.post('/send-bulk-email/', data);
      
      // Option 2: If backend is at /admin/send-bulk-email/
      // const response = await axiosService.post('/admin/send-bulk-email/', data);
      
      // Option 3: If backend is at /send-bulk-email/
      const response = await axiosService.post('/email/send-bulk-email/', data);
      
      console.log('Response:', response);
      
      if (response.status === 200) {
        setSuccessMessage("Emails sent successfully!");
        setSubject("");
        setMessage("");
      } else {
        setErrorMessage("An error occurred while sending the emails.");
      }
    } catch (error) {
      console.error('Full error:', error);
      
      // Better error handling
      if (error.response) {
        // Server responded with error status
        setErrorMessage(error.response.data?.error || error.response.data?.message || `Server error: ${error.response.status}`);
      } else if (error.request) {
        // Request was made but no response
        setErrorMessage("No response from server. Please check if backend is running.");
      } else {
        // Something else happened
        setErrorMessage(error.message || "Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 12 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h5" component="h2" gutterBottom sx={{ mb: 3 }}>
          Send Emails to All Users
        </Typography>

        <form onSubmit={(e) => {
          e.preventDefault();
          handleSendEmails();
        }}>
          <TextField
            fullWidth
            label="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            margin="normal"
            required
            disabled={loading}
            variant="outlined"
          />

          <TextField
            fullWidth
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            multiline
            rows={6}
            margin="normal"
            required
            disabled={loading}
            variant="outlined"
          />

          <Box sx={{ mt: 3, mb: 2 }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
              fullWidth
              sx={{ py: 1 }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Send Emails"}
            </Button>
          </Box>
        </form>

        {successMessage && (
          <Alert severity="success" sx={{ mt: 2 }} onClose={() => setSuccessMessage("")}>
            {successMessage}
          </Alert>
        )}

        {errorMessage && (
          <Alert severity="error" sx={{ mt: 2 }} onClose={() => setErrorMessage("")}>
            {errorMessage}
          </Alert>
        )}
      </Paper>
    </Container>
  );
};

export default SendEmailsPage;